import { PropsWithChildren, forwardRef } from 'react';
import { IonPage } from '@ionic/react';
import { useTheme } from 'styled-components';

import { PageContext } from '../../contexts/PageContext';
import { ThemePaletteColor, ThemeGradientColor } from '../../types';

export type PageProps = PropsWithChildren<{
  background?: ThemePaletteColor;
  headerBackground?: ThemePaletteColor | ThemeGradientColor;
  loading?: boolean;
}>;

export const Page = forwardRef<HTMLDivElement, PageProps>(
  (
    { children, headerBackground = 'transparent', background = 'white100' },
    ref
  ) => {
    const { palette } = useTheme();

    return (
      <IonPage ref={ref} style={{ backgroundColor: palette[background] }}>
        <PageContext.Provider value={{ background, headerBackground }}>
          {children}
        </PageContext.Provider>
      </IonPage>
    );
  }
);
